import About from "./components/About";
import Contact from "./components/Contact";
import Experience from "./components/Experience";
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import KeyHighlights from "./components/ImpactReport";
import FeaturedProjects from "./components/FeaturedProjects";
import WritingAndBlogs from "./components/EngineeringJournal";

function App() {
  return (
    <div>
      <Navbar />
      <Home />
      <About />
      <KeyHighlights />
      <FeaturedProjects />
      <Experience />
      <WritingAndBlogs />
      <Skills />
      <Projects />
      <Contact />
    </div>
  );
}

export default App;
